import axios from 'axios'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Baseurl } from '../../../Config/Baseurl'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import totalImage from '../../assets/images/total.svg'
import approvedImage from '../../assets/images/approved.svg'
import pendingIamge from '../../assets/images/pending.svg'
import rejecetdImage from '../../assets/images/rejected.svg'

export const AdminDashboard = () => {
  const [total, setTotal] = useState()
  const [approved, setApproved] = useState()
  const [pending, setPending] = useState()
  const [rejected, setRejected] = useState()
  const getData = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'statistics/totalReimburse')
      .then((res) => {
        setTotal(res.data.data[0])
      })
      .catch((err) => {})
    await axios
      .get(Baseurl.nodeLocal + 'statistics/totalApproved')
      .then((res) => {
        setApproved(res.data.data[0])
      })
      .catch((err) => {})
    await axios
      .get(Baseurl.nodeLocal + 'statistics/totalPending')
      .then((res) => {
        setPending(res.data.data[0])
      })
      .catch((err) => {})
    await axios
      .get(Baseurl.nodeLocal + 'statistics/totalRejected')
      .then((res) => {
        setRejected(res.data.data[0])
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //  datshboard to display latest request table and card of
  // pending,completed,on hold,rejected request with count and amount
  return (
    <div className="adminDashboard row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div
        className="adminDashboardContainer col-md-10 d-flex align-items-center justify-content-center"
        style={{ height: '100vh' }}
      >
        <div className="container d-flex align-items-center justify-content-center flex-column">
          <div className="row p-4 mt-5">
            <div
              className="card mx-2 p-4"
              style={{
                backgroundColor: '#112E46',
                color: 'white',
                width: '20rem',
              }}
            >
              <div className="row g-0">
                <div className="col-md-4">
                  <div
                    className="totalImage border border-white border-2 rounded-circle d-flex justify-content-center align-items-center"
                    style={{ height: '80px', width: '80px' }}
                  >
                    <img
                      src={totalImage}
                      className="img-fluid"
                      alt="..."
                      height={10}
                      width={50}
                    />
                  </div>
                </div>
                <div className="card-body d-flex justify-content-start row col-md-8">
                  <h6>{total ? total.count : ''} Bills Received Total</h6>
                  <span
                    style={{ fontSize: '24px' }}
                    className="d-flex justify-content-start"
                  >
                    ₹{' '}
                    {total
                      ? total.total_amount === null
                        ? '0'
                        : total.total_amount
                      : ''}
                  </span>
                </div>
              </div>
            </div>
            <div
              className="card mx-2 p-4"
              style={{
                backgroundColor: '#00A57F',
                color: 'white',
                width: '20rem',
              }}
            >
              <div className="row g-0">
                <div className="col-md-4">
                  <div
                    className="totalImage border border-white border-2 rounded-circle d-flex justify-content-center align-items-center"
                    style={{ height: '80px', width: '80px' }}
                  >
                    <img
                      src={approvedImage}
                      className="img-fluid"
                      alt="..."
                      height={10}
                      width={40}
                    />
                  </div>
                </div>
                <div className="card-body d-flex justify-content-start row col-md-8">
                  <h6>{approved ? approved.count : ''} Bills Approved For</h6>
                  <span
                    style={{ fontSize: '24px' }}
                    className="d-flex justify-content-start"
                  >
                    ₹{' '}
                    {approved
                      ? approved.total_amount === null
                        ? '0'
                        : approved.total_amount
                      : ''}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row p-4">
            <div
              className=" card mx-2 p-4"
              style={{
                backgroundColor: '#FDAD8D',
                color: 'white',
                width: '20rem',
              }}
            >
              <div className="row g-0">
                <div className="col-md-4">
                  <div
                    className="totalImage border border-white border-2 rounded-circle d-flex justify-content-center align-items-center"
                    style={{ height: '80px', width: '80px' }}
                  >
                    <img
                      src={pendingIamge}
                      className="img-fluid"
                      alt="..."
                      height={10}
                      width={40}
                    />
                  </div>
                </div>
                <div className="card-body d-flex justify-content-start row col-md-8">
                  <h6>{pending ? pending.count : ''} Bills Pending For</h6>
                  <span
                    style={{ fontSize: '24px' }}
                    className="d-flex justify-content-start"
                  >
                    ₹{' '}
                    {pending
                      ? pending.total_amount === null
                        ? '0'
                        : pending.total_amount
                      : ''}
                  </span>
                </div>
              </div>
            </div>
            <div
              className="card mx-2 p-4 overflow-visible"
              style={{
                backgroundColor: '#F6508E',
                color: 'white',
                width: '20rem',
              }}
            >
              <div className="row g-0">
                <div className="col-md-4">
                  <div
                    className="totalImage border border-white border-2 rounded-circle d-flex justify-content-center align-items-center"
                    style={{ height: '80px', width: '80px' }}
                  >
                    <img
                      src={rejecetdImage}
                      className="img-fluid"
                      alt="..."
                      height={10}
                      width={40}
                    />
                  </div>
                </div>
                <div className="card-body d-flex justify-content-start row col-md-8">
                  <h6>{rejected ? rejected.count : ''} Bills Rejected For</h6>
                  <span
                    style={{ fontSize: '24px' }}
                    className="d-flex justify-content-start"
                  >
                    ₹{' '}
                    {rejected
                      ? rejected.total_amount === null
                        ? '0'
                        : rejected.total_amount
                      : ''}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
